import React, { useState, useEffect, useRef } from "react";
import AuthService from "../../api/AuthService";
import { planService, subscriptionService } from "../../api";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import CompanyInfoPage from "../../entities/SignupPage/companyInfo";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { redirectToCheckout } from "../../utils/checkout";

const CompanyInfo = () => {
  const navigate = useNavigate();
  const {showAlert} = useAlert();
  const [loading,setLoading] = useState(false);
  const [industry, setIndustry] = useState([]);
  const [data, setData] = useState(""); 
  const isCompanyCreated = useRef(false);

  const normalizeId = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value.trim();
    return String(value?._id || value?.id || "").trim();
  };

  const normalizeListResponse = (response) => {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response?.result)) return response.result;
    return [];
  };

  const isRequestSuccessful = (response) =>
    response?.success === true ||
    response?.status === true ||
    (response && response?.success !== false && response?.error !== true);

  const resolvePlanId = async () => {
    const storedPlanId =
      localStorage.getItem("planId") ||
      localStorage.getItem("selectedPlanId") ||
      localStorage.getItem("defaultPlanId") ||
      "";

    if (String(storedPlanId).trim()) {
      return String(storedPlanId).trim();
    }

    return "";
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/");
      return;
    }
    
    const checkExistingCompany = async () => {
      try {
        const companyResult = await AuthService.getCompantList();
        if (companyResult?.success && companyResult?.data?.[0]?.companyName) {
          isCompanyCreated.current = true;
        }
      } catch (error) {
        // ignore error
      }
    };
    checkExistingCompany();
    getindustry();

    const handleBeforeUnload = () => {
      if (!isCompanyCreated.current) {
        localStorage.clear();
      }
    };

    const handlePopState = () => {
      if (!isCompanyCreated.current) {
        localStorage.clear();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [])


  const handleCompanyDetails = async(data,cCode,mobile) => {
    setLoading(true)
    setData("")
    try {
      const result = await AuthService.companyInfo(data,cCode,mobile);
      if (isRequestSuccessful(result)) {
        isCompanyCreated.current = true;
        const companyData = result?.data || {};
        const companyId = normalizeId(companyData?._id || companyData?.id);
        const adminId = normalizeId(
          companyData?.admin ||
          localStorage.getItem("userId") ||
          localStorage.getItem("employeeId") ||
          localStorage.getItem("id")
        );

        if (companyId) {
          localStorage.setItem("companyId", companyId);
          localStorage.setItem("id", companyId);
        }
        if (adminId) {
          localStorage.setItem("userId", adminId);
        }

        const planId = await resolvePlanId();

        if (!companyId || !adminId) {
          setLoading(false);
          showAlert("Unable to create subscription. Missing company/admin details.", "error");
          return;
        }

        const subscriptionPayload = {
          companyId,
          adminId,
          planId,
          date: new Date().toISOString(),
          isActive: true,
        };

        if (planId) {
        const subscriptionResult = await subscriptionService.create(subscriptionPayload);

        if (isRequestSuccessful(subscriptionResult)) {
          const authorizationUrl =
            subscriptionResult?.data?.authorizationUrl ||
            subscriptionResult?.data?.data?.authorizationUrl ||
            subscriptionResult?.authorizationUrl ||
            "";

          if (authorizationUrl) {
            redirectToCheckout(authorizationUrl);
            return;
          }

          // showAlert(subscriptionResult?.message || result?.message || "Company details updated successfully.", "success");
        } else {
          showAlert(subscriptionResult?.message || "Subscription creation failed.", "error");
        }
        } else {
          // If no planId, we skip subscription creation and consider company creation successful
          navigate("/dashboard");
          // showAlert("Company details updated successfully.", "success");
        }
      } else {
        
        setLoading(false)
        showAlert(result?.message,"error");
        return;
      }
    } catch (error) {
      setLoading(false)
      showAlert(error?.message || "Something went wrong while saving company details.", "error");
      return;
    } finally {
      setLoading(false);
    }
  };

  const getindustry = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getindustry();
      if (result?.success) {
        setIndustry(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <CompanyInfoPage loading={loading} handleCompany={handleCompanyDetails} industryList={industry} data={data} />
  )

}

export default CompanyInfo;
